import {
  CountryCode,
  parsePhoneNumberWithError,
  PhoneNumber
} from "libphonenumber-js";

export const parsePhoneNumber = (
  phoneNumberString: string,
  country: CountryCode
): PhoneNumber | undefined => {
  try {
    const phoneNumber = parsePhoneNumberWithError(phoneNumberString, {
      defaultCountry: country,
      // Demand that the entire input string must be a phone number.
      // Otherwise, it would "extract" a phone number from an input string.
      extract: false
    });
    /* eslint-disable no-console */
    console.log("phone number", phoneNumber);
    return phoneNumber;
  } catch (e) {
    /* eslint-disable no-console */
    console.error(e);
    return undefined;
  }
};

export const cleanPhoneNumber = (
  phoneNumber: string,
  countryCode: string
): string => {
  // 🧼 Strip leading 0 if it exists
  const normalizedPhone = phoneNumber.startsWith("0")
    ? phoneNumber.slice(1)
    : phoneNumber;

  // 🔗 Concatenate with country code
  return `${countryCode}${normalizedPhone}`;
};

export const isValidPhoneNumberForCountry = (
  phoneNumberString: string,
  country: CountryCode,
  phoneCountryCode: string
): boolean => {
  const cleanedPhone = cleanPhoneNumber(phoneNumberString, phoneCountryCode);
  const phoneNumber = parsePhoneNumber(cleanedPhone, country);
  // Check if phone number is valid
  // and if the country code matches the provided one
  // and if the country calling code matches the provided one
  // and if the phone number is not falsy
  if (!phoneNumber) {
    return false;
  }
  if (phoneNumber.country !== country) {
    return false;
  }

  if (`+${phoneNumber.countryCallingCode}` !== phoneCountryCode) {
    return false;
  }
  return phoneNumber.isValid();
};
